import '../styles/Services.css';
import React, { useEffect } from 'react';
import {
  FaStar,
  FaBalanceScale,
  FaLaptopCode,
  FaLeaf,
  FaHardHat,
  FaBookOpen,
} from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';

const Services = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });

    // If user comes from Appointment button, highlight Research card
    if (window.location.hash === '#highlight-research') {
      const el = document.getElementById('research-consultancy');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });

        el.classList.add('highlight-card');
        setTimeout(() => {
          el.classList.remove('highlight-card');
        }, 2000);
      }
    }
  }, []);

  return (
    <section className="services-section" id="services">
      <h2 data-aos="fade-up">Our Services</h2>
      <div className="services-container">
        <Link to="/services/astrology" className="service-link">
          <div className="service-card" data-aos="zoom-in">
            <FaStar className="service-icon" />
            <h3>Astrology Consultancy</h3>
            <p>Personalized predictions and guidance by professional astrologers.</p>
          </div>
        </Link>

        <Link to="/services/law" className="service-link">
          <div className="service-card" data-aos="zoom-in" data-aos-delay="100">
            <FaBalanceScale className="service-icon" />
            <h3>Law Consultancy</h3>
            <p>Legal advice and support for students and professionals.</p>
          </div>
        </Link>

        <Link to="/services/cs-projects" className="service-link">
          <div className="service-card" data-aos="zoom-in" data-aos-delay="200">
            <FaLaptopCode className="service-icon" />
            <h3>CS Projects (UG/PG/PHD)</h3>
            <p>End-to-end support for academic and research projects in Computer Science.</p>
          </div>
        </Link>

        <Link to="/services/homeopathy" className="service-link">
          <div className="service-card" data-aos="zoom-in" data-aos-delay="300">
            <FaLeaf className="service-icon" />
            <h3>Homeopathy Consultancy</h3>
            <p>Consult certified homeo doctors for holistic health solutions.</p>
          </div>
        </Link>

        <Link to="/services/civil" className="service-link">
          <div className="service-card" data-aos="zoom-in" data-aos-delay="400">
            <FaHardHat className="service-icon" />
            <h3>Civil Works Consultancy</h3>
            <p>Expert guidance on structural and construction engineering solutions.</p>
          </div>
        </Link>

        <Link to="/services/research" className="service-link" id="research-consultancy">
          <div className="service-card" data-aos="zoom-in" data-aos-delay="500">
            <FaBookOpen className="service-icon" />
            <h3>Research Consultancy</h3>
            <p>Expert help with thesis, publications, and research mentoring (UG/PG/PHD).</p>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default Services;
